require('select2');

export const setupCompanySuggestSelect = function(element, methodType, url, type, callback) {
	element.select2({
		tags: true,
		placeholder: '企業を選択して下さい',
		dropdownAutoWidth: true,
		width: 'auto',
		allowClear: true,
		ajax: {
			type: methodType,
			async: true,
			url: url,
            headers: {
            	'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
			data: function (params) {
				var query = {
					search: params.term,
					type: type,
				}
				return query;
			},
			minimumInputLength: 2,
			delay: 300,
			cache: true,
			processResults: callback
		}
	});
	var params = element.data('init');
	if (params) {
		params.split(',').filter(item => {
			let val = item.split(':');
			var opt = new Option(val[1], val[0], false, false);
			element.append(opt);
		});
		element.trigger('change');
	}
};

// 汎用的なサジェスト設定をセットアップする
export const setupBasicSuggestSelect = function(selector, url, placeholder, paramaterFilter, templateResult, templateSelection) {
	var element = $(selector);
	var initExclusions = element.data('init-exclusions');
	element.attr('data-exclusions', JSON.stringify(initExclusions));

	element.select2({
        tags: true,
        placeholder: placeholder,
        dropdownAutoWidth: true,
        width: 'auto',
        allowClear: true,
        ajax: {
            type: 'POST',
            async: true,
            url: url,
			headers: {
				'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			},
            data: paramaterFilter?? defaultParamaterFilter,
            minimumInputLength: 2,
            delay: 200,
            cache: true,
            processResults: function(data) {
				let exclusions = getExclusions(selector);
				exclusions = Array.from(new Set(exclusions.concat(initExclusions)));
				if (exclusions.length && data.results) {
					// exclusions指定時は、選択できないアイテムを設定
					data.results = data.results.filter(item => {
						if (item.children) {
							item.children = item.children.filter(i => !exclusions.includes(i.id));
							return item.children.length > 0;
						} else {
							return !exclusions.includes(item.id);
						}
					});
				}
				let target = this.$element;
				if (data.results && data.results.length == 0 && target.val()) {
					// 選択中の場合で検索結果が無ければ、選択中の要素を追加する
					data.results = [{ id:target.val(), text:target.find('option:selected').text() }]
				}
                return data;
            },
        },
        templateResult: templateResult??defaultTemplateResultItem,
        templateSelection: templateSelection??defaultTemplateSelectionItem
    });
	var initItem = element.data('init');
	if (initItem) {
		// 初期値を設定
		if (initItem.length) {
			initItem.forEach(function(item) {
				var opt = new Option(templateSelection??defaultTemplateSelectionItem(item).html(), item.id, false, false);
				element.append(opt);
			});
			element.val(initItem.map((item)=>item.id)).trigger('change');
		} else {
			var opt = new Option(templateSelection??defaultTemplateSelectionItem(initItem).html(), initItem.id, false, false);
			element.append(opt);
			element.val(initItem.id).trigger('change');
		}
	}
}

// デフォルトのパラメータフィルター
function defaultParamaterFilter(params) {
	var query = {
		search: params.term,
	}
	return query;
}

// デフォルトのアイテムテンプレート
function defaultTemplateResultItem(data) {
	if (!data.id || data.loding) {
		// group or Searching...
		return $(`<span><b>${data.text}</b></span>`);
	}

	return $(`<span>${data.text}</span>`);
}

// デフォルトの選択時表示テンプレート
function defaultTemplateSelectionItem(data) {
	if (!data.id || data.loding) {
		// placeholder or Searching...
		return $(`<span>${data.text}</span>`);
	}

	return $(`<span>${data.text}</span>`);
}

// 除外リスト取得
function getExclusions(selector) {
	// 更新するdata属性はjQueryでは取得できないためネイティブJSで取得する
	let ele = document.querySelector(selector);
	let json = ele? ele.getAttribute('data-exclusions'): null;
	return json? JSON.parse(json): [];
}

// 除外リスト設定
function setExclusions(selector, val) {
	let ele = document.querySelector(selector);
	if (ele) {
		let json = ele.setAttribute('data-exclusions', JSON.stringify(val));
	}
}
